import React from 'react'
import PropTypes from 'prop-types'
import { ASD } from '../../config/account'
import AccountCD from './UserInfoAccountCD'

const UserInfoAccount = ({ account, onClick }) => {
  const { as } = account
  const asd = ASD[as]
  const labels = asd[0]
  const offer = asd[1]
  let notHiLiOffer = false
  let pureOffer = offer
  if (offer.charAt(0) === '#') {
    notHiLiOffer = true
    pureOffer = offer.replace('#', '')
  }
  let butCls = notHiLiOffer ? 'up-ui-bu' : 'up-ui-bu but-hig'
  let items = []
  for (let i = 1; i < labels.length; i++) {
    let cls = null
    let item = labels[i]
    if (item.charAt(0) === '$') {
      cls = 'up-ui-lab-g'
      item = item.replace('$', '')
    }
    if (item.charAt(0) === '#') {
      cls = 'up-ui-lab-r'
      item = item.replace('#', '')
    }
    items.push(<p key={i} className={cls}>{item}</p>)
  }
  return (
    <React.Fragment>
      <label className='up-ui-te'>
        <p className='up-ui-lab-m'>{labels[0]}</p>
        <AccountCD account={account} />
        {items}
      </label>
      <button className={butCls} onClick={onClick}>
        {pureOffer}
      </button>
    </React.Fragment>
  )
}

UserInfoAccount.propTypes = {
  account: PropTypes.object,
  onClick: PropTypes.func
}

export default UserInfoAccount


// WEBPACK FOOTER //
// ./src/components/User/UserInfoAccount.js